import _slicedToArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { Button } from '@design-system/button';
import { ErrorMessage } from '@design-system/error-message';
import { Field, FieldType } from '@phx-husky/field';
import { useTranslations } from '@phx-husky/use-translations';
import classNames from 'classnames';
import { useState, useEffect } from 'react';
function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}
var css_248z = ".confirm-code-module_form__Anjk5 {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n}\n\n.confirm-code-module_container__mhMBq {\n  width: 100%;\n  position: relative;\n}\n\n.confirm-code-module_resendCodeButton__GTqjw {\n  position: absolute;\n  top: 42px;\n  outline-offset: 2px;\n}\n\n[dir=ltr] .confirm-code-module_resendCodeButton__GTqjw {\n  right: 16px;\n}\n\n[dir=rtl] .confirm-code-module_resendCodeButton__GTqjw {\n  left: 16px;\n}\n\n.confirm-code-module_resendCodeMessage__m0d0j {\n  margin: var(--cds-space-2) 0;\n  color: var(--phx-resendInformationTextColor, #0146db);\n}\n\n.confirm-code-module_resendCodeMessage__m0d0j.cds-error-icon {\n  margin: 0px;\n  width: var(--cds-icon-size-xs);\n  height: var(--cds-icon-size-xs);\n}\n\n.confirm-code-module_submit__OLgzz {\n  margin-top: var(--cds-space-5);\n  width: 100%;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImNvbmZpcm0tY29kZS5tb2R1bGUuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLFdBQVc7RUFDWCxhQUFhO0VBQ2Isc0JBQXNCO0VBQ3RCLGVBQWU7QUFDakI7O0FBRUE7RUFDRSxXQUFXO0VBQ1gsa0JBQWtCO0FBQ3BCOztBQUVBO0VBQ0Usa0JBQWtCO0VBRWxCLFNBQVM7RUFDVCxtQkFBbUI7QUFDckI7O0FBTEE7RUFFRSxXQUFXO0FBR2I7O0FBTEE7RUFFRSxVQUFXO0FBR2I7O0FBRUE7RUFDRSw0QkFBNEI7RUFDNUIscURBQXFEO0FBQ3ZEOztBQUNBO0VBQ0UsV0FBVztFQUNYLDhCQUE4QjtFQUM5QiwrQkFBK0I7QUFDakM7O0FBRUE7RUFDRSw4QkFBOEI7RUFDOUIsV0FBVztBQUNiIiwiZmlsZSI6ImNvbmZpcm0tY29kZS5tb2R1bGUuc2NzcyIsInNvdXJjZXNDb250ZW50IjpbIi5mb3JtIHtcbiAgd2lkdGg6IDEwMCU7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gIGZsZXgtd3JhcDogd3JhcDtcbn1cblxuLmNvbnRhaW5lciB7XG4gIHdpZHRoOiAxMDAlO1xuICBwb3NpdGlvbjogcmVsYXRpdmU7XG59XG5cbi5yZXNlbmRDb2RlQnV0dG9uIHtcbiAgcG9zaXRpb246IGFic29sdXRlO1xuICByaWdodDogMTZweDtcbiAgdG9wOiA0MnB4O1xuICBvdXRsaW5lLW9mZnNldDogMnB4O1xufVxuXG4ucmVzZW5kQ29kZU1lc3NhZ2Uge1xuICBtYXJnaW46IHZhcigtLWNkcy1zcGFjZS0yKSAwO1xuICBjb2xvcjogdmFyKC0tcGh4LXJlc2VuZEluZm9ybWF0aW9uVGV4dENvbG9yLCAjMDE0NmRiKTtcbn1cbi5yZXNlbmRDb2RlTWVzc2FnZTpnbG9iYWwoLmNkcy1lcnJvci1pY29uKSB7XG4gIG1hcmdpbjogMHB4O1xuICB3aWR0aDogdmFyKC0tY2RzLWljb24tc2l6ZS14cyk7XG4gIGhlaWdodDogdmFyKC0tY2RzLWljb24tc2l6ZS14cyk7XG59XG5cbi5zdWJtaXQge1xuICBtYXJnaW4tdG9wOiB2YXIoLS1jZHMtc3BhY2UtNSk7XG4gIHdpZHRoOiAxMDAlO1xufSJdfQ== */";
var styles = {
  "form": "confirm-code-module_form__Anjk5",
  "container": "confirm-code-module_container__mhMBq",
  "resendCodeButton": "confirm-code-module_resendCodeButton__GTqjw",
  "resendCodeMessage": "confirm-code-module_resendCodeMessage__m0d0j",
  "submit": "confirm-code-module_submit__OLgzz"
};
styleInject(css_248z);
var TIME_TO_REFRESH = 60;
var ConfirmCode = function ConfirmCode(_ref) {
  var _ref$additionalData = _ref.additionalData,
    additionalData = _ref$additionalData === void 0 ? {
      prefix: 'modal',
      translationPrefix: 'modal'
    } : _ref$additionalData,
    submit = _ref.submit,
    errorMessage = _ref.errorMessage,
    resendCode = _ref.resendCode,
    pending = _ref.pending;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    code = _useState2[0],
    setCode = _useState2[1];
  var _useTranslations = useTranslations(),
    translate = _useTranslations.translate;
  var prefix = additionalData.prefix,
    translationPrefix = additionalData.translationPrefix;
  var _useState3 = useState(TIME_TO_REFRESH),
    _useState4 = _slicedToArray(_useState3, 2),
    timeToActive = _useState4[0],
    setTimeToActive = _useState4[1];
  var startCountdown = function startCountdown() {
    setTimeToActive(TIME_TO_REFRESH);
    var interval = setInterval(function () {
      setTimeToActive(function (t) {
        if (t <= 0) {
          clearInterval(interval);
        }
        return t - 1;
      });
    }, 1000);
    return interval;
  };
  useEffect(function () {
    var interval = startCountdown();
    return function () {
      clearInterval(interval);
    };
  }, []);
  var handleField = function handleField(fieldValue) {
    var value = '';
    if (fieldValue.target) {
      value = fieldValue.target.value;
    } else {
      value = fieldValue.value;
    }
    setCode(value);
  };
  var resendCodeClick = function resendCodeClick(event) {
    if (!resendCode || timeToActive > 0) {
      return;
    }
    resendCode(event);
    startCountdown();
  };
  return jsxs("form", Object.assign({
    className: classNames(styles.form, 'confirm-code__form'),
    onSubmit: function onSubmit(e) {
      return submit(e, code);
    }
  }, {
    children: [jsxs("div", Object.assign({
      className: classNames(styles.container, 'confirm-code__container')
    }, {
      children: [jsx(Field, {
        id: "code",
        name: "code",
        type: FieldType.textbox,
        "data-translate-key": "registerConfirmationCode",
        label: translate('registerConfirmationCode'),
        value: code,
        errorMessage: errorMessage,
        onChange: handleField
      }, "code"), resendCode ? jsxs(Fragment, {
        children: [jsx(Button, Object.assign({
          type: "button",
          variant: "subtle",
          size: "large",
          id: "resend-code-button",
          className: styles.resendCodeButton,
          "data-translate-key": "".concat(translationPrefix, "ResendButton"),
          onClick: resendCodeClick,
          disabled: pending || timeToActive > 0
        }, {
          children: translate("".concat(translationPrefix, "ResendButton"))
        })), timeToActive > 0 ? jsx(ErrorMessage, {
          className: styles.resendCodeMessage,
          message: translate('codeResendPossibleIn', undefined, timeToActive.toString())
        }) : null]
      }) : null]
    })), jsx(Button, Object.assign({
      type: "submit",
      variant: "primary",
      size: "large",
      className: classNames(styles.submit, 'confirm-code__submit'),
      id: "".concat(prefix, "-submit"),
      "data-translate-key": "".concat(translationPrefix, "ConfirmButton")
    }, {
      children: translate("".concat(translationPrefix, "ConfirmButton"))
    }))]
  }));
};
export { ConfirmCode as default };